import logo from './logo.svg';
import './App.css';
import Header from './layout/Header';
import SideNav from './layout/SideNav';
import Dashboard from './pages/Dashboard';
import { AppProvider } from './AppContext';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from './Auth/Auth';
import routes from './Routes';
import { RequireAuth } from './Auth/RequireAuth';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ToastContainer />
        <AuthProvider>
          <Routes>
            {routes.map((route, index) => {
              const Component = route.component;

              return (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    route.auth ? (
                      <RequireAuth>
                        <>
                          <Header />
                          <div className="container-fluid">
                            <div className="row">
                              <SideNav />
                              <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 auto-scroll">
                                <Component />
                              </main>
                            </div>
                          </div>
                        </>
                      </RequireAuth>
                    ) : (
                      <Component />
                    )
                  }
                />
              );
            })}
          </Routes>
        </AuthProvider>
        <div id="loader" >
          <div class="spinner"></div>
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}
export default App;
